import React from 'react'
import {SignInputPassword, SignInputPhone, SignInputVCode} from "./signInputs";
import {Link} from "react-router-dom";
import {LoginBtn, SuccessToLogin} from "./signCmp";
import {Path} from "../public/path";
import {CaptchaType} from "../public/mtype";
import CorpApi from "../public/corp_api";
import Message from "../cmpts/ant/Message";
import Util from "../public/utils";

const DefaultFindError = {
    phone: {
        error: false,
        errorDes: ''
    },
    password: {
        error: false,
        errorDes: '密码应为6-16位字符，包含字母和数字'
    },
    vcode: {
        error: false,
        errorDes: ''
    }
};

class FindPass extends React.Component {

    constructor(props) {
        super(props);
        this.phoneNoNotExists = this.phoneNoNotExists.bind(this);
        this.resetPassSuccess = this.resetPassSuccess.bind(this);
        this.codeError = this.codeError.bind(this);
        this.findPassOver = this.findPassOver.bind(this);
        this.beginFindPass = this.beginFindPass.bind(this);
        this.state = {
            findError: JSON.parse(JSON.stringify(DefaultFindError)),
            findPassSuccess: false,
            isFindPass: false
        };
        this.FindRef = {};
    }

    componentDidMount() {
        let target = Util.getUrlArg("target");
        if (target) {
            this.setState({target: target});
        }
    }

    submit() {
        if (!this.state.isFindPass) {
            let findError = this.state.findError;
            if (findError.phone.error || findError.password.error || findError.vcode.error) {
                this.setState({
                    findError: JSON.parse(JSON.stringify(DefaultFindError))
                })
            }
            let phone = this.FindRef.phone;
            let vcode = this.FindRef.vcode;
            let password = this.FindRef.password;
            if (phone.check() && vcode.check() && password.check()) {
                let params = {
                    phoneNo: phone.getValue(),
                    password: Util.hashPwd(password.getValue()),
                    captcha: vcode.getValue()
                };
                let phoneNoNotExists = this.phoneNoNotExists;
                let resetPassSuccess = this.resetPassSuccess;
                let codeError = this.codeError;
                let findPassOver = this.findPassOver.bind(this);
                this.beginFindPass();
                CorpApi.userFindPass(params, function () {
                    //重置成功
                    resetPassSuccess();
                }, function (resp) {
                    //重置失败
                    let respCode = resp.respCode;
                    if (respCode == 40025) {
                        //验证码错误
                        codeError();
                    } else if (respCode == 40026) {
                        //注册手机号不存在
                        phoneNoNotExists();
                    }
                    findPassOver();
                }, function () {
                    findPassOver();
                })
            }
        }
    }

    beginFindPass() {
        this.setState({
            isFindPass: true
        })
    }

    findPassOver() {
        this.setState({
            isFindPass: false
        })
    }

    resetPassSuccess() {
        this.setState({
            findPassSuccess: true,
            isFindPass: false
        })
    }

    codeError() {
        let findError = this.state.findError;
        findError.vcode.error = true;
        findError.vcode.errorDes = '验证码错误';
        this.setState({
            findError: findError
        })
    }

    sendCode(callback) {
        let phone = this.FindRef.phone;
        if (phone.check()) {
            let params = {
                phoneNo: phone.getValue(),
                type: CaptchaType.ResetPassword
            };
            let phoneNoNotExists = this.phoneNoNotExists;
            //调用接口发送验证码
            CorpApi.userCaptcha(params, function () {
                if (callback) {
                    callback();
                }
            }, function (resp) {
                let respCode = resp.respCode;
                if (respCode == 40027) {
                    //验证码请求太频繁
                    Message.error("验证码发送太频繁，请稍后再试");
                } else if (respCode == 40026) {
                    phoneNoNotExists();
                } else {
                    Message.error("验证码发送太频繁，请稍后再试");
                }
            });
        }
    }

    phoneNoNotExists() {
        let findError = this.state.findError;
        findError.phone.error = true;
        findError.phone.errorDes = '手机号不存在';
        this.setState({
            findError: findError
        })
    }

    render() {
        if (this.state.findPassSuccess) {
            return <SuccessToLogin title='密码重置成功' target={this.state.target}/>
        } else {
            return (
                <div className='login-wraper account-single'>
                    <div className='account-type'>
                        <p className={'account-type-item account-type-item-active'}>重置密码</p>
                    </div>
                    <div className='account-login-wraper'>
                        <div className='signinput-wraper'>
                            <SignInputPhone key='find-phone' ref={r => this.FindRef.phone = r}
                                            error={this.state.findError.phone.error}
                                            errorDes={this.state.findError.phone.errorDes}
                                            onEnter={this.submit.bind(this)}/>
                            <SignInputVCode key='find-vcode' ref={r => this.FindRef.vcode = r}
                                            onEnter={this.submit.bind(this)}
                                            error={this.state.findError.vcode.error}
                                            errorDes={this.state.findError.vcode.errorDes}
                                            sendCode={this.sendCode.bind(this)}/>
                            <SignInputPassword key='find-passwrod' ref={r => this.FindRef.password = r}
                                               error={this.state.findError.password.error}
                                               errorDes={this.state.findError.password.errorDes}
                                               defaultErrorDes='密码应为6-16位字符，包含字母和数字'
                                               placeholder='新密码：6-16位字符，包含字母和数字' onEnter={this.submit.bind(this)}/>
                        </div>
                        <LoginBtn btnText="确定" btnOnClick={this.submit.bind(this)}
                                  loading={this.state.isFindPass}
                                  loginSwitch={<span>已有账号？<Link
                                      to={Path.getUserLogin(this.state.target)}>马上登录</Link></span>}/>
                    </div>
                </div>
            )
        }
    }
}

export default FindPass